export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7452.1b3be631.jpg";